/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Build_Remove_OneInputs */

const en_us2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Take ${i?.name} out of the workout`)
};

const pt_br2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tirar ${i?.name} do treino`)
};

const es_419_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quitar ${i?.name} del entrenamiento`)
};

const pt_pt2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tirar ${i?.name} do treino`)
};

const fr_fr2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.name} de la séance`)
};

const de_de2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aus dem Training nehmen`)
};

const it_it2_plan_build_remove_one = /** @type {(inputs: Plan_Build_Remove_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Togli ${i?.name} dall'allenamento`)
};

/**
* | output |
* | --- |
* | "Take {name} out of the workout" |
*
* @param {Plan_Build_Remove_OneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_remove_one = /** @type {((inputs: Plan_Build_Remove_OneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Remove_OneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_remove_one(inputs)
	if (locale === "es-419") return es_419_plan_build_remove_one(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_remove_one(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_remove_one(inputs)
	if (locale === "de-DE") return de_de2_plan_build_remove_one(inputs)
	if (locale === "it-IT") return it_it2_plan_build_remove_one(inputs)
	return en_us2_plan_build_remove_one(inputs)
});
export { plan_build_remove_one as "plan-build.remove_one" }